const pageData = {
  'used-cars': {
    shortName: 'Used',
    path: '/used-cars',
    name: 'used-cars',
    type: 'used',
    friendlyName: 'used cars',
    seconderyTitle: 'Why buy with What Car?',
    dataSection: 'classifieds-results',
    searchFormName: 'used-cars-for-sale',
    description:
      "Car-buying can be complex, but at What Car? we’ve got more than 45 years of experience of helping people buy the best car for their budget. And because our classifieds are powered by AutoTrader, you know that you're choosing from the biggest selection of used cars available in the UK.",
    homeText: {
      whatcar: {
        title: 'Why you should buy with What Car?',
        description:
          "Car-buying can be complex, but at What Car? we’ve got more than 50 years of experience helping people buy the best car for their budget. What's more, we've partnered with Autotrader to bring you the biggest selection of used cars available in the UK."
      },
      autocar: {
        title: 'Why you should buy with Autocar?',
        description:
          "There has never been more choice than now when it comes to buying a car, which can make finding the right car for you a daunting process. But it's also an exciting one. You can trust Autocar to steer you towards the very best car for your needs and budget - just as we have been doing since 1895. And because our classifieds are powered by AutoTrader, you know that you're choosing from the biggest selection of used cars available in the UK."
      }
    }
  },
  'new-cars-in-stock': {
    shortName: 'In stock cars',
    path: '/new-cars-in-stock',
    name: 'new-cars-in-stock',
    type: 'in stock cars',
    friendlyName: 'in stock cars',
    seconderyTitle: 'Why buy with What Car?',
    dataSection: 'stock-car-results',
    searchFormName: 'stock-cars-for-sale',
    description:
      "Car-buying can be complex, but at What Car? we’ve got more than 45 years of experience of helping people buy the best car for their budget. And because our classifieds are powered by AutoTrader, you know that you're choosing from the biggest selection of used cars available in the UK.",
    homeText: {
      whatcar: {
        title: 'Why you should buy with What Car?',
        description:
          "Car-buying can be complex, but at What Car? we’ve got more than 50 years of experience helping people buy the best car for their budget. What's more, we've partnered with Autotrader to bring you the biggest selection of discounted new cars available in the UK."
      },
      autocar: {
        title: 'Why you should buy with Autocar?	',
        description:
          "There has never been more choice than now when it comes to buying a car, which can make finding the right car for you a daunting process. But it's also an exciting one. You can trust Autocar to steer you towards the very best car for your needs and budget - just as we have been doing since 1895. And because our in-stock car pages are powered by AutoTrader, you know that you're choosing from one of the biggest selections of discounted new cars available in the UK."
      }
    }
  },
  'car-leasing-deals': {
    shortName: 'Leasing',
    path: '/car-leasing-deals',
    name: 'car-leasing-deals',
    type: 'leasing',
    friendlyName: 'leasing cars',
    listTitle: 'Leasing deals on What Car?',
    seconderyTitle: 'TBC - Why buy with What Car?',
    dataSection: 'leasing-results',
    searchFormName: 'leasing-deals-on-whatcar',
    description:
      "TBC ---- Car-buying can be complex, but at What Car? we’ve got more than 45 years of experience of helping people buy the best car for their budget. And because our classifieds are powered by AutoTrader, you know that you're choosing from the biggest selection of used cars available in the UK.",
    homeText: {
      whatcar: {
        title: 'Why you should lease with What Car?',
        description:
          "Choosing a new car can be complex, but at What Car? we’ve got more than 50 years of experience helping people get the best car for their budget. What's more, we've partnered with Autotrader to bring you the biggest selection of new cars available to lease in the UK."
      },
      autocar: {
        title: 'Why you should lease with Autocar?',
        description:
          "Choosing a new car can be complex, but at Autocar we’ve got more than 50 years of experience helping people get the best car for their budget. What's more, we've partnered with Autotrader to bring you the biggest selection of new cars available to lease in the UK."
      }
    }
  }
};

export default pageData;



// WEBPACK FOOTER //
// ./src/utils/pageData/index.js